/* Winterbreathe — page d'accueil.
 * Lit les données rendues par sections/winterbreath-home.liquid (#wb-data),
 * pilote la bascule de couleur par parfum, l'empilement des sticks, la chute
 * de fruits, et l'ajout au vrai panier Shopify via l'API AJAX du panier. */
(function () {
  'use strict';

  var dataEl = document.getElementById('wb-data');
  var root = document.getElementById('wb-root');
  if (!dataEl || !root) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var LANG = DATA.lang === 'fr' ? 'fr' : 'en';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ copy */
  var UI = {
    fr: {
      heroShop: 'Choisir mon parfum',
      takeFlavour: function (n) { return 'Choisir ce goût · ' + n; },
      heroLearn: 'Pourquoi ça marche',
      pickEyebrow: 'Choisis ton parfum',
      pickH2: 'Le site prend<br>ta couleur.',
      flavcount: function (n, l) { return n + ' parfums · gamme ' + l.toLowerCase(); },
      buildEyebrow: 'Compose ton lot',
      buildH2On: 'Chaque stick ajouté<br>enlève 10 %.',
      buildH2Off: 'Compose<br>ton lot.',
      buildPOn: 'Ajoute un deuxième parfum : il se glisse derrière le premier. Le troisième et le quatrième s\'empilent pareil, et la remise se creuse à chaque fois.',
      buildPOff: 'Ajoute jusqu\'à quatre sticks, un parfum par emplacement. Le deuxième se glisse derrière le premier, puis le troisième et le quatrième.',
      stick: 'stick', sticks: 'sticks', single: 'À l\'unité',
      front: 'Stick de devant',
      behind: function (i) { return 'Derrière n°' + i; },
      flavourLbl: 'Parfum',
      stackOff: function (p) { return 'Lot −' + p + ' %'; },
      launchOff: 'Lancement −20 %',
      total: 'Total',
      perStick: ' le stick',
      launchT: 'Offre de lancement −20 %',
      launchD: 'Réservée aux 10 premières commandes. Le code est appliqué automatiquement au paiement.',
      cta: 'Ajouter au panier',
      adding: 'Ajout en cours…',
      fineDisc: 'Remises appliquées automatiquement au paiement.',
      fineStd: 'Paiement sécurisé · expédition suivie.',
      added: function (q, w) { return q + ' ' + w + ' ajouté' + (q > 1 ? 's' : '') + ' au panier'; },
      addError: 'Impossible d\'ajouter au panier. Réessaie dans un instant.',
      soldOut: 'Épuisé',
      cart: 'Panier',
      cartEmpty: 'Ton panier est vide.',
      checkout: 'Passer commande',
      cartNote: 'Livraison et taxes calculées au paiement.',
      subtotal: 'Sous-total',
      saved: function (m) { return 'Tu économises ' + m; },
      remove: 'Retirer',
      galEyebrow: 'Le produit, en vrai',
      galH2: 'Ce que tu<br>reçois.',
      specEyebrow: 'Le stick lui-même',
      specH2: 'Caractéristiques',
      faqEyebrow: 'Avant de demander',
      faqH2: 'Questions',
      disc: '<b>Winterbreathe</b> — inhalateurs et bâtonnets d\'aromathérapie.<br><br>Produits parfumés destinés à une sensation de fraîcheur et à un usage d\'aromathérapie. Ce ne sont pas des dispositifs médicaux. Ils ne contiennent ni nicotine ni substance médicamenteuse, et ne sont destinés ni à diagnostiquer, traiter, guérir ou prévenir une maladie, ni à traiter une dépendance à la nicotine. Cesser l\'utilisation en cas d\'irritation. Tenir hors de portée des enfants et éloigné des yeux.'
    },
    en: {
      heroShop: 'Pick my flavour',
      takeFlavour: function (n) { return 'Get this flavour · ' + n; },
      heroLearn: 'Why it works',
      pickEyebrow: 'Pick your flavour',
      pickH2: 'The site takes<br>your colour.',
      flavcount: function (n, l) { return n + ' flavours · ' + l.toLowerCase() + ' range'; },
      buildEyebrow: 'Build your stack',
      buildH2On: 'Every stick you add<br>takes 10% off.',
      buildH2Off: 'Build<br>your stack.',
      buildPOn: 'Add a second flavour and it slides in behind the first. Third and fourth stack the same way, and the discount deepens with each one.',
      buildPOff: 'Add up to four sticks, one flavour per slot. The second slides in behind the first, then the third and fourth.',
      stick: 'stick', sticks: 'sticks', single: 'Single',
      front: 'Front stick',
      behind: function (i) { return 'Behind #' + i; },
      flavourLbl: 'Flavour',
      stackOff: function (p) { return 'Stack −' + p + '%'; },
      launchOff: 'Launch −20%',
      total: 'Total',
      perStick: ' per stick',
      launchT: 'Launch offer −20%',
      launchD: 'For the first 10 orders only. The code is applied automatically at checkout.',
      cta: 'Add to cart',
      adding: 'Adding…',
      fineDisc: 'Discounts are applied automatically at checkout.',
      fineStd: 'Secure checkout · tracked shipping.',
      added: function (q, w) { return q + ' ' + w + ' added to cart'; },
      addError: 'Couldn\'t add to cart. Please try again in a moment.',
      soldOut: 'Sold out',
      cart: 'Cart',
      cartEmpty: 'Your cart is empty.',
      checkout: 'Checkout',
      cartNote: 'Shipping and taxes calculated at checkout.',
      subtotal: 'Subtotal',
      saved: function (m) { return 'You save ' + m; },
      remove: 'Remove',
      galEyebrow: 'The real thing',
      galH2: 'What you<br>get.',
      specEyebrow: 'The stick itself',
      specH2: 'Specifications',
      faqEyebrow: 'Before you ask',
      faqH2: 'Questions',
      disc: '<b>Winterbreathe</b> — aromatherapy inhalers and sticks.<br><br>Scent products for a cooling sensation and aromatherapy use. They are not medical devices, contain no nicotine and no medicinal ingredient, and are not intended to diagnose, treat, cure or prevent any disease, nor to treat nicotine dependence. Stop use if irritation occurs. Keep away from children and from the eyes.'
    }
  };

  var COPY = {
    peak: {
      label: { fr: 'Inhalateur', en: 'Inhaler' },
      fr: {
        eyebrow: 'Stick nasal double conduit · 2 g',
        h1: 'Respire<br>froid.<br><em id="wb-heroflav">Tiens le rythme.</em>',
        lede: 'Un coup de frais en une inspiration : une sensation d\'air glacé qui traverse le nez, et tu repars. Deux conduits, format poche, sans caféine ni sucre.',
        galNote: 'Photos du produit que tu reçois. Le flacon et son marquage d\'origine changent selon le parfum.',
        tags: ['Fraîcheur immédiate', 'Double conduit', 'Sans caféine ni sucre', 'Format poche', 'Plusieurs semaines d\'usage'],
        whyEyebrow: 'Pourquoi il traîne dans les sacs de sport',
        whyH2: 'Fait pour la série<br>d\'avant la série.',
        whyP: 'Ni complément, ni boisson. Un coup de parfum frais en une inspiration, au moment où la tête commence à partir.',
        why: [
          ['01 / AVANT LA SÉRIE', 'Le reset entre deux séries', 'Une inspiration fraîche, et le brouillard de la série précédente se lève. Le bon moment : les 30 secondes avant de repartir.'],
          ['02 / FRAÎCHEUR', 'Cette sensation d\'air frais', 'Les arômes donnent une fraîcheur vive au passage de l\'air, qui donne l\'impression que l\'inspiration a plus de place.'],
          ['03 / RIEN À AVALER', 'Rien dont il faut redescendre', 'Tu ne bois rien, tu n\'avales rien : tu inspires un parfum. Pas de caféine, pas de sucre, rien à caler dans ton entraînement.']
        ],
        spec: [['Format', 'Stick nasal double conduit'], ['Poids net', '2 g'], ['Parfums', '#'], ['Conservation', '24 mois'], ['Utilisation', 'Inhalation externe'], ['Livraison', 'Suivie, 7 à 25 jours ouvrés']],
        faq: [
          ['Comment on l\'utilise ?', 'Tu retires le capuchon, tu places un conduit juste sous une narine et tu inspires calmement, puis tu changes de côté. Rien n\'entre dans le nez.'],
          ['Un stick dure combien de temps ?', 'En général plusieurs semaines d\'usage régulier : le parfum est retenu dans une mèche et se diffuse lentement. Conservation : 24 mois.'],
          ['Je commence par quel parfum ?', 'Pour la fraîcheur la plus nette, commence par la Menthe Alpine. Pour plus de douceur, Pêche Givrée ou Lime Arctique.'],
          ['On l\'utilise quand ?', 'Entre deux séries, après l\'effort, au bureau vers 15 h, en voiture, avant un rendez-vous : dès que tu as envie d\'un coup de frais. Il tient dans une poche de short.'],
          ['Le flacon ressemble à quoi ?', 'Il change selon le parfum : chaque parfum a son flacon d\'origine, celui que tu vois en photo quand tu le sélectionnes.'],
          ['Quels délais de livraison ?', 'Compte 7 à 25 jours ouvrés selon ta destination. La livraison est suivie : le numéro de suivi t\'est envoyé par e-mail dès l\'expédition.']
        ]
      },
      en: {
        eyebrow: 'Dual-channel nasal stick',
        h1: 'Breathe<br>cold.<br><em id="wb-heroflav">Train hot.</em>',
        lede: 'A cold hit in one breath: an icy rush of air through the nose, and you go again. Two channels, pocket size, no caffeine, no sugar.',
        galNote: 'Photos of the product you receive. The bottle and its original markings vary by flavour.',
        tags: ['Instant freshness', 'Dual channel', 'No caffeine, no sugar', 'Pocket size', 'Weeks of use'],
        whyEyebrow: 'Why athletes keep one in the bag',
        whyH2: 'Made for the<br>set before the set.',
        whyP: 'Not a supplement and not a drink. A fresh scent hit in one breath, at the point where your head starts drifting.',
        why: [
          ['01 / PRE-SET', 'The reset between rounds', 'One fresh breath and the fog of the last set lifts. The right moment: the 30 seconds before you go again.'],
          ['02 / FRESHNESS', 'That fresh-air feeling', 'The aromas give a sharp, cool sensation as the air comes in, so a breath feels like it has more room.'],
          ['03 / NOTHING TO SWALLOW', 'Nothing to come down from', 'You don\'t drink or swallow anything: you breathe in a scent. No caffeine, no sugar, nothing to time around training.']
        ],
        spec: [['Format', 'Dual-channel nasal stick'], ['Flavours', '#'], ['Shelf life', '24 months'], ['Use', 'External inhalation'], ['Delivery', 'Tracked, 7 to 25 business days']],
        faq: [
          ['How do I use it?', 'Pull the cap, hold a channel just under one nostril and breathe in steadily, then swap sides. Nothing goes inside your nose.'],
          ['How long does one stick last?', 'Usually several weeks of regular use: the scent sits in a wick and releases slowly. Shelf life is 24 months.'],
          ['Which flavour should I start with?', 'For the sharpest freshness, start with Alpine Mint. For something softer, Frost Peach.'],
          ['When do people use it?', 'Between sets, after training, at a desk around 3 p.m., in the car, before a meeting: whenever you want a cold hit. It fits a shorts pocket.'],
          ['What does the bottle look like?', 'It depends on the flavour: each one comes in its original bottle, the one shown when you select it.'],
          ['How long is delivery?', 'Allow 7 to 25 business days depending on where you are. Every order is tracked, and the tracking number is emailed to you as soon as it ships.']
        ]
      }
    },
    'switch': {
      label: { fr: 'Bâtonnet', en: 'Stick' },
      fr: {
        eyebrow: 'Stick parfumé pour les mains · sans nicotine',
        h1: 'Autre chose<br>vers quoi<br><em id="wb-heroflav">tendre la main.</em>',
        lede: 'Le geste main-bouche ne disparaît pas parce qu\'on a décidé d\'arrêter. Le Bâtonnet lui donne une destination : un stick parfumé aux plantes. Sans nicotine, sans vapeur, sans combustion.',
        galNote: 'Photos du produit que tu reçois, avec son sachet d\'origine.',
        tags: ['Sans nicotine', 'Sans tabac', 'Ni vapeur ni fumée', 'Utilisable en intérieur', '5 parfums'],
        whyEyebrow: 'Pourquoi ça marche comme substitution',
        whyH2: 'Le geste, c\'est<br>la moitié de l\'habitude.',
        whyP: 'L\'essentiel de ce qu\'on va chercher, c\'est le rituel. Le Bâtonnet garde le rituel et laisse tomber le reste.',
        why: [
          ['01 / LE RITUEL', 'Occupe les mains', 'La même forme, le même geste, la même pause. Ce qui manque, c\'est la fumée, la cendre et l\'odeur qui te suit à l\'intérieur.'],
          ['02 / PARFUM SEUL', 'Végétal, pas chimique', 'Cinq parfums tirés à travers un cœur en fibre végétale. Rien ne brûle, rien ne se vaporise.'],
          ['03 / PARTOUT', 'Pour les pauses, partout', 'Quand tu attends, quand tu cogites, quand tes mains cherchent quelque chose. Rien n\'est produit : au bureau, en voiture, dans le train.']
        ],
        spec: [['Format', 'Stick parfumé à tirer'], ['Nicotine', 'Aucune'], ['Tabac', 'Aucun'], ['Combustion', 'Aucune'], ['Cœur', 'Fibre végétale parfumée'], ['Après ouverture', '36 mois']],
        faq: [
          ['C\'est une méthode pour arrêter de fumer ?', 'Non, et on ne le vend pas comme ça. Le Bâtonnet est un stick parfumé pour le geste main-bouche. Il ne contient ni nicotine ni médicament, donc il ne peut pas traiter une dépendance. Si tu veux arrêter, parle à un pharmacien ou à un médecin.'],
          ['Ça produit de la vapeur ou de la fumée ?', 'Non : il n\'y a ni résistance chauffante, ni liquide, ni combustion. Tu tires de l\'air à travers un cœur en fibre végétale parfumée.'],
          ['Je peux l\'utiliser en intérieur ?', 'Oui. Rien ne brûle et rien n\'est émis : pas de fumée, pas d\'odeur, aucun dépôt.'],
          ['Ça dure combien de temps ?', 'L\'intensité du parfum baisse avec l\'usage, en général sur une à deux semaines de tirages réguliers. Durée après ouverture : 36 mois.']
        ]
      },
      en: {
        eyebrow: 'Flavour stick for the hands · nicotine-free',
        h1: 'Something<br>else to<br><em id="wb-heroflav">reach for.</em>',
        lede: 'The hand-to-mouth habit doesn\'t disappear because you decide it should. The Stick gives it somewhere to go: a herbal flavour stick. No nicotine, no vapour, no combustion.',
        galNote: 'Photos of the product you receive, in its original pack.',
        tags: ['Nicotine-free', 'Tobacco-free', 'No vapour, no smoke', 'Fine indoors', '5 flavours'],
        whyEyebrow: 'Why it works as a substitution',
        whyH2: 'The gesture is<br>half the habit.',
        whyP: 'Most of what people reach for is the ritual. The Stick keeps the ritual and drops everything else.',
        why: [
          ['01 / THE RITUAL', 'Keeps your hands busy', 'The same shape, the same gesture, the same pause. What\'s missing is the smoke, the ash and the smell that follows you indoors.'],
          ['02 / FLAVOUR ONLY', 'Herbal, not chemical', 'Five flavours drawn through a plant-fibre core. Nothing burns, nothing vaporises.'],
          ['03 / ANYWHERE', 'For the pauses, anywhere', 'While you wait, while you think, when your hands want something to do. Nothing is produced: at a desk, in a car, on a train.']
        ],
        spec: [['Format', 'Draw-through flavour stick'], ['Nicotine', 'None'], ['Tobacco', 'None'], ['Combustion', 'None'], ['Core', 'Flavour-infused plant fibre'], ['After opening', '36 months']],
        faq: [
          ['Is this a way to stop smoking?', 'No, and we don\'t sell it as one. The Stick is a flavour stick for the hand-to-mouth habit. It contains no nicotine and no medicine, so it can\'t treat dependence. If you want to stop, talk to a pharmacist or a doctor.'],
          ['Does it produce vapour or smoke?', 'No: there is no heating element, no liquid and no combustion. You draw air across a flavoured plant-fibre core.'],
          ['Can I use it indoors?', 'Yes. Nothing burns and nothing is emitted: no smoke, no smell, no residue.'],
          ['How long does one last?', 'Flavour fades with use, usually over one to two weeks of regular draws. Period after opening is 36 months.']
        ]
      }
    }
  };

  /* Option value of each Shopify variant → flavour identity. Keys are
   * normalised; French aliases keep working if the variants get renamed. */
  function F(order, fr, en, h, s, fruit, nfr, nen) {
    return { order: order, name: { fr: fr, en: en }, h: h, s: s, fruit: fruit, note: { fr: nfr, en: nen } };
  }
  var PEAK = {
    peaches: F(0, 'Pêche Givrée', 'Frost Peach', 14, 88, 'round', 'Douceur glacée.', 'Soft and icy.'),
    mint: F(1, 'Menthe Alpine', 'Alpine Mint', 170, 72, 'leaf', 'Tiens le rythme.', 'Train hot.'),
    'lime basil': F(2, 'Lime Arctique', 'Arctic Lime', 86, 72, 'citrus', 'Réveille-toi.', 'Wake up.'),
    grape: F(3, 'Raisin Givré', 'Glacier Grape', 265, 64, 'cluster', 'Concentre-toi.', 'Lock in.'),
    watermelon: F(4, 'Melon Glacé', 'Frozen Melon', 340, 70, 'round', 'Redescends.', 'Cool down.'),
    herbal: F(5, 'Herbe Sauvage', 'Wild Herb', 126, 52, 'leaf', 'Reste lucide.', 'Stay sharp.'),
    'fresh mint': F(6, 'Menthe Polaire', 'Polar Mint', 192, 70, 'leaf', 'Respire froid.', 'Breathe cold.'),
    'red bull': F(7, 'Éclair Bleu', 'Blue Surge', 214, 76, 'round', 'Repars.', 'Go again.'),
    lemon: F(2, 'Citron Arctique', 'Arctic Lemon', 58, 86, 'citrus', 'Réveille-toi.', 'Wake up.')
  };
  var SWITCH = {
    mint: F(0, 'Menthe Fraîche', 'Refreshing Mint', 166, 62, 'leaf', 'tendre la main.', 'reach for.'),
    watermelon: F(1, 'Pastèque', 'Watermelon', 342, 66, 'round', 'tendre la main.', 'reach for.'),
    grape: F(2, 'Raisin Glacé', 'Iced Grape', 280, 56, 'cluster', 'tenir en main.', 'hold onto.'),
    'green tea': F(3, 'Thé Vert', 'Green Tea', 102, 44, 'leaf', 'te poser.', 'settle on.'),
    'ice cream': F(4, 'Glace à l\'Eau', 'Classic Popsicle', 34, 58, 'round', 'ralentir.', 'slow down.')
  };
  /* Real product cut-outs (theme assets, URLs in DATA.photos). `photo` is the
   * packshot, `stick` the single item used in the stack. The inhaler bottle
   * itself differs by flavour (NICOR, HANBOLI or LIVER from the supplier). */
  [['peaches', 'inh-peche'], ['mint', 'inh-menthe-alpine'], ['lime basil', 'inh-lime'], ['grape', 'inh-raisin'],
    ['watermelon', 'inh-melon'], ['herbal', 'inh-herbe'], ['fresh mint', 'inh-polaire'], ['red bull', 'inh-eclair'],
    ['lemon', 'inh-lemon']
  ].forEach(function (p) { PEAK[p[0]].photo = p[1]; PEAK[p[0]].stick = p[1]; });
  [['mint', 'bat-menthe', 'bat-stick-vert'], ['watermelon', 'bat-pasteque', 'bat-stick-rouge'], ['grape', 'bat-raisin', 'bat-stick-violet'],
    ['green tea', 'bat-the', 'bat-stick-vert'], ['ice cream', 'bat-glace', 'bat-stick-noir']
  ].forEach(function (p) { SWITCH[p[0]].photo = p[1]; SWITCH[p[0]].stick = p[2]; });
  function photoUrl(key) { return key && DATA.photos ? DATA.photos[key] || '' : ''; }
  function norm(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }
  function aliasMap(base) {
    var m = {};
    Object.keys(base).forEach(function (k) {
      var f = base[k];
      m[norm(k)] = f;
      m[norm(f.name.fr)] = f;
      m[norm(f.name.en)] = f;
    });
    return m;
  }
  var FMAP = { peak: aliasMap(PEAK), 'switch': aliasMap(SWITCH) };

  function hashHue(s) {
    var h = 0;
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
    return h;
  }
  function buildFlavours(line) {
    var p = DATA.products[line];
    if (!p) return [];
    var seen = {};
    var out = [];
    p.variants.forEach(function (v) {
      var f = FMAP[line][norm(v.opt)];
      var key = f ? norm(f.name.en) : norm(v.opt);
      if (seen[key]) return;
      seen[key] = true;
      var base = f || F(99, v.opt, v.opt, hashHue(norm(v.opt)), 60, 'round', '', '');
      out.push({
        id: key,
        variantId: v.id,
        price: v.price,
        available: v.available,
        order: base.order,
        name: base.name,
        h: base.h,
        s: base.s,
        fruit: base.fruit,
        note: base.note,
        photo: base.photo || '',
        stick: base.stick || ''
      });
    });
    out.sort(function (a, b) { return a.order - b.order; });
    return out;
  }
  var FLAVOURS = { peak: buildFlavours('peak'), 'switch': buildFlavours('switch') };
  var VARIANT_INDEX = {};
  ['peak', 'switch'].forEach(function (line) {
    FLAVOURS[line].forEach(function (f) { VARIANT_INDEX[f.variantId] = { line: line, flavour: f }; });
  });

  /* ------------------------------------------------------------ state */
  var LINES = ['peak', 'switch'].filter(function (l) { return FLAVOURS[l].length; });
  if (!LINES.length) return;
  var MAX = 4;
  var STACK = [0, 0, 0.1, 0.2, 0.3];
  var LAUNCH_OFF = 0.2;
  var state = { line: LINES[0], flavour: null, qty: 1, picks: [], cart: null, busy: false };

  function T() { return UI[LANG]; }
  function C() { return COPY[state.line][LANG]; }
  function fl() { return FLAVOURS[state.line]; }
  function fname(f) { return f ? f.name[LANG] || f.name.en : ''; }
  function lname(line) { return COPY[line || state.line].label[LANG]; }
  function flavById(id, line) {
    var fs = FLAVOURS[line || state.line];
    for (var i = 0; i < fs.length; i++) if (fs[i].id === id) return fs[i];
    return fs[0];
  }
  function firstAvailable(line) {
    var fs = FLAVOURS[line];
    for (var i = 0; i < fs.length; i++) if (fs[i].available) return fs[i];
    return fs[0];
  }
  function defaultPicks(line) {
    var fs = FLAVOURS[line].filter(function (f) { return f.available; });
    if (!fs.length) fs = FLAVOURS[line];
    var picks = [];
    for (var i = 0; i < MAX; i++) picks.push(fs[i % fs.length].id);
    return picks;
  }
  function word(q) { return q === 1 ? T().stick : T().sticks; }
  function hsl(h, s, l) { return 'hsl(' + h + ' ' + s + '% ' + l + '%)'; }
  function $(id) { return document.getElementById(id); }
  function setT(id, v) { var e = $(id); if (e) e.textContent = v; }
  function setH(id, v) { var e = $(id); if (e) e.innerHTML = v; }

  var fmt;
  try {
    fmt = new Intl.NumberFormat(DATA.locale || LANG, { style: 'currency', currency: DATA.currency || 'EUR' });
  } catch (e) {
    fmt = { format: function (n) { return n.toFixed(2) + ' ' + (DATA.currency || ''); } };
  }
  function money(cents) { return fmt.format(cents / 100); }

  /* ------------------------------------------------------------ theme */
  var SOBER = {
    bg: '#08080b', surf: '#101016', surf2: '#17171f', line: '#26262f', tx: '#f6f6f8',
    mute: '#9b9ba6', faint: '#6a6a75', acc: '#dc2626', onAcc: '#ffffff',
    glow: 'rgba(220,38,38,.28)', wash: 'rgba(220,38,38,.07)'
  };
  function vivid(f) {
    var h = f.h, s = f.s;
    return {
      bg: hsl(h, Math.round(s * 0.86), 94), surf: hsl(h, Math.round(s * 0.7), 98),
      surf2: hsl(h, Math.round(s * 0.8), 89), line: hsl(h, Math.round(s * 0.56), 79),
      tx: hsl(h, Math.round(s * 0.66), 11), mute: hsl(h, Math.round(s * 0.3), 33),
      faint: hsl(h, Math.round(s * 0.22), 49), acc: hsl(h, s, 44), onAcc: hsl(h, 55, 98),
      glow: 'hsl(' + h + ' ' + s + '% 60% / .40)', wash: 'hsl(' + h + ' ' + s + '% 55% / .13)'
    };
  }
  function theme() {
    var p = state.flavour ? vivid(flavById(state.flavour)) : SOBER;
    var r = document.documentElement.style;
    r.setProperty('--wb-bg', p.bg); r.setProperty('--wb-surf', p.surf); r.setProperty('--wb-surf-2', p.surf2);
    r.setProperty('--wb-line', p.line); r.setProperty('--wb-tx', p.tx); r.setProperty('--wb-tx-mute', p.mute);
    r.setProperty('--wb-tx-faint', p.faint); r.setProperty('--wb-acc', p.acc); r.setProperty('--wb-on-acc', p.onAcc);
    r.setProperty('--wb-glow', p.glow); r.setProperty('--wb-wash', p.wash);
  }
  function paintOf(f) {
    if (!f) return { hi: '#fca5a5', mid: '#dc2626', lo: '#7f1d1d', ink: 'rgba(255,255,255,.9)' };
    return { hi: hsl(f.h, f.s, 78), mid: hsl(f.h, f.s, 57), lo: hsl(f.h, f.s, 33), ink: 'hsl(' + f.h + ' ' + Math.round(f.s * 0.7) + '% 14% / .72)' };
  }

  /* ---------------------------------------------------------- product */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function stickSVG(f, idx) {
    var c = paintOf(f);
    var u = 'wbu' + state.line + (f ? f.id.replace(/\W/g, '') : 'x') + idx;
    var nm = esc(f ? fname(f).toUpperCase() : 'WINTERBREATHE');
    var sw = state.line === 'switch';
    return '<svg viewBox="0 0 200 284" role="img" aria-label="' + esc(f ? fname(f) : 'Winterbreathe') + '">' +
      '<defs><linearGradient id="b' + u + '" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="' + c.lo + '"/><stop offset=".34" stop-color="' + c.mid + '"/>' +
      '<stop offset=".62" stop-color="' + c.hi + '"/><stop offset="1" stop-color="' + c.lo + '"/></linearGradient>' +
      '<linearGradient id="c' + u + '" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="' + c.lo + '"/>' +
      '<stop offset=".45" stop-color="' + c.mid + '"/><stop offset="1" stop-color="' + c.lo + '"/></linearGradient></defs>' +
      (sw
        ? '<rect x="74" y="8" width="52" height="64" rx="26" fill="' + c.hi + '"/>' +
          '<rect x="74" y="66" width="52" height="8" rx="4" fill="' + c.lo + '" opacity=".5"/>' +
          '<rect x="74" y="74" width="52" height="202" rx="26" fill="url(#b' + u + ')"/>' +
          '<rect x="82" y="88" width="9" height="176" rx="4.5" fill="rgba(255,255,255,.4)"/>'
        : '<rect x="52" y="8" width="96" height="92" rx="46" fill="url(#c' + u + ')"/>' +
          '<ellipse cx="84" cy="27" rx="9" ry="7" fill="rgba(0,0,0,.5)"/>' +
          '<ellipse cx="116" cy="27" rx="9" ry="7" fill="rgba(0,0,0,.5)"/>' +
          '<rect x="52" y="98" width="96" height="7" rx="3.5" fill="rgba(255,255,255,.34)"/>' +
          '<rect x="52" y="103" width="96" height="173" rx="30" fill="url(#b' + u + ')"/>' +
          '<rect x="64" y="116" width="15" height="146" rx="7.5" fill="rgba(255,255,255,.4)"/>') +
      '<text x="100" y="' + (sw ? 180 : 194) + '" text-anchor="middle" fill="' + c.ink + '" font-family="Bebas Neue,Impact,sans-serif" font-size="' + (sw ? 15 : 21) + '" letter-spacing="1">WINTER</text>' +
      '<text x="100" y="' + (sw ? 196 : 216) + '" text-anchor="middle" fill="' + c.ink + '" font-family="Bebas Neue,Impact,sans-serif" font-size="' + (sw ? 15 : 21) + '" letter-spacing="1">BREATHE</text>' +
      '<text x="100" y="' + (sw ? 224 : 245) + '" text-anchor="middle" fill="' + c.ink + '" opacity=".8" font-family="Source Sans 3,sans-serif" font-weight="600" font-size="' + (sw ? 7 : 9) + '" letter-spacing=".9">' + nm + '</text></svg>';
  }
  function stickArt(f, idx) {
    // Before any flavour is chosen, the entry stays on the red illustration.
    if (!state.flavour) return stickSVG(null, idx);
    var src = f ? photoUrl(f.stick) : '';
    if (!src) return stickSVG(f, idx);
    return '<img src="' + esc(src) + '" alt="' + (idx === 0 ? esc(lname() + ' ' + fname(f)) : '') + '"' +
      ' class="wb-photo' + (state.line === 'switch' ? ' wb-photo-thin' : '') + '" decoding="async"' +
      (idx === 0 ? ' fetchpriority="high"' : ' loading="lazy"') + '>';
  }
  function renderStack() {
    var host = $('wb-stack');
    host.innerHTML = '';
    for (var i = MAX - 1; i >= 0; i--) {
      var f = state.picks[i] ? flavById(state.picks[i]) : null;
      var el = document.createElement('div');
      el.className = 'wb-stick' + (i >= state.qty ? ' wb-ghost' : '');
      var dir = i % 2 === 0 ? 1 : -1, step = Math.ceil(i / 2);
      var spread = state.line === 'switch' ? 40 : 22;
      var tx = dir * step * spread, rot = dir * step * 6.5, sc = 1 - i * 0.055;
      if (i >= state.qty) { tx = 0; rot = 0; sc = 0.9; }
      el.style.transform = 'translateX(' + tx + 'px) rotate(' + rot + 'deg) scale(' + sc + ')';
      el.style.zIndex = String(50 - i);
      el.innerHTML = stickArt(f, i);
      host.appendChild(el);
    }
    renderGallery();
  }

  /* Gallery: real cut-outs of the current range. The main frame follows the
   * front flavour; thumbnails let the visitor browse the other shots. */
  var gallerySel = null;
  function galleryShots() {
    var shots = [], seen = {};
    function add(key, label) {
      var u = photoUrl(key);
      if (!u || seen[key]) return;
      seen[key] = true;
      shots.push({ key: key, url: u, label: label });
    }
    var front = state.picks[0] ? flavById(state.picks[0]) : null;
    if (front) add(front.photo, fname(front));
    if (state.line === 'switch') {
      add('bat-gamme', LANG === 'fr' ? 'Les bâtonnets' : 'The sticks');
      add('bat-sachets', LANG === 'fr' ? 'Les 5 sachets' : 'All 5 packs');
    }
    fl().forEach(function (f) { if (f.available) add(f.photo, fname(f)); });
    fl().forEach(function (f) { add(f.photo, fname(f)); });
    return shots;
  }
  function renderGallery() {
    var main = $('wb-gmain'), th = $('wb-gthumbs');
    if (!main || !th) return;
    var shots = galleryShots(), t = T();
    if (!shots.length) { $('wb-gallery').hidden = true; return; }
    $('wb-gallery').hidden = false;
    var cur = shots[0];
    for (var i = 0; i < shots.length; i++) if (shots[i].key === gallerySel) cur = shots[i];
    var img = main.querySelector('img');
    if (!img) { img = document.createElement('img'); img.decoding = 'async'; main.appendChild(img); }
    if (img.getAttribute('src') !== cur.url) {
      img.classList.remove('wb-in');
      img.src = cur.url;
      void img.offsetWidth;
      img.classList.add('wb-in');
    }
    img.alt = lname() + ' — ' + cur.label;
    img.className = 'wb-in' + (/^bat-(gamme|sachets)$/.test(cur.key) ? ' wb-wide' : '');
    setT('wb-gcap', cur.label);
    setT('wb-g-eyebrow', t.galEyebrow);
    setH('wb-g-h2', t.galH2);
    setT('wb-g-note', C().galNote);
    th.innerHTML = '';
    shots.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wb-gthumb';
      b.setAttribute('aria-pressed', String(s.key === cur.key));
      b.setAttribute('aria-label', s.label);
      var im = document.createElement('img');
      im.src = s.url;
      im.alt = '';
      im.loading = 'lazy';
      im.decoding = 'async';
      b.appendChild(im);
      b.addEventListener('click', function () { gallerySel = s.key; renderGallery(); });
      th.appendChild(b);
    });
  }

  /* ----------------------------------------------------------- render */
  function renderCopy() {
    var c = C(), t = T();
    setT('wb-hero-eyebrow', c.eyebrow);
    setH('wb-hero-h1', c.h1);
    setT('wb-hero-lede', c.lede);
    var hf = $('wb-heroflav');
    if (hf && state.flavour) hf.textContent = flavById(state.flavour).note[LANG];
    setT('wb-btn-shop', t.heroShop);
    renderTake();
    setT('wb-btn-learn', t.heroLearn);
    var tg = $('wb-hero-tags');
    tg.innerHTML = '';
    c.tags.forEach(function (x) { var s = document.createElement('span'); s.className = 'wb-tag'; s.textContent = x; tg.appendChild(s); });

    setT('wb-pick-eyebrow', t.pickEyebrow);
    setH('wb-pick-h2', t.pickH2);
    setT('wb-flavcount', t.flavcount(fl().length, lname()));
    $('wb-fgrid').setAttribute('aria-label', t.pickEyebrow);
    setT('wb-build-eyebrow', t.buildEyebrow);
    setH('wb-build-h2', DATA.stackEnabled ? t.buildH2On : t.buildH2Off);
    setT('wb-build-p', DATA.stackEnabled ? t.buildPOn : t.buildPOff);
    setT('wb-k-total', t.total);
    setT('wb-k-launch', t.launchOff);
    setT('wb-fineprint', DATA.stackEnabled || DATA.launchEnabled ? t.fineDisc : t.fineStd);
    setT('wb-launch-t', t.launchT);
    setT('wb-launch-d', t.launchD);
    $('wb-launchbox').hidden = !DATA.launchEnabled;
    setT('wb-d-title', t.cart);
    setT('wb-d-tk', t.total);
    setT('wb-d-checkout', t.checkout);
    setT('wb-d-note', t.cartNote);

    setT('wb-why-eyebrow', c.whyEyebrow);
    setH('wb-why-h2', c.whyH2);
    setT('wb-why-p', c.whyP);
    var cc = $('wb-why-cards');
    cc.innerHTML = '';
    c.why.forEach(function (w) {
      var d = document.createElement('div');
      d.className = 'wb-card';
      d.innerHTML = '<span class="wb-num"></span><h3></h3><p></p>';
      d.querySelector('.wb-num').textContent = w[0];
      d.querySelector('h3').textContent = w[1];
      d.querySelector('p').textContent = w[2];
      cc.appendChild(d);
    });

    setT('wb-spec-eyebrow', t.specEyebrow);
    setT('wb-spec-h2', t.specH2);
    var sp = $('wb-spec');
    sp.innerHTML = '';
    c.spec.forEach(function (s) {
      var d = document.createElement('div');
      d.className = 'wb-sline';
      d.innerHTML = '<span class="wb-k"></span><span class="wb-v"></span>';
      d.querySelector('.wb-k').textContent = s[0];
      d.querySelector('.wb-v').textContent = s[1] === '#' ? String(fl().length) : s[1];
      sp.appendChild(d);
    });

    setT('wb-faq-eyebrow', t.faqEyebrow);
    setT('wb-faq-h2', t.faqH2);
    var fq = $('wb-faq');
    fq.innerHTML = '';
    c.faq.forEach(function (q, i) {
      var d = document.createElement('details');
      if (i === 0) d.open = true;
      var s = document.createElement('summary');
      s.textContent = q[0];
      var p = document.createElement('p');
      p.textContent = q[1];
      d.appendChild(s);
      d.appendChild(p);
      fq.appendChild(d);
    });
    setH('wb-disc', t.disc);
  }

  function renderSeg() {
    var h = $('wb-seg');
    h.innerHTML = '';
    if (LINES.length < 2) { h.hidden = true; return; }
    LINES.forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-pressed', String(state.line === k));
      b.textContent = lname(k);
      b.addEventListener('click', function () {
        if (state.line === k) return;
        state.line = k;
        state.flavour = null;
        gallerySel = null;
        state.qty = 1;
        state.picks = defaultPicks(k);
        theme();
        recolour();
        renderAll();
      });
      h.appendChild(b);
    });
  }

  function renderTake() {
    var b = $('wb-btn-take');
    if (!b) return;
    var f = state.flavour ? flavById(state.flavour) : null;
    b.hidden = !(f && f.available);
    if (f) b.textContent = T().takeFlavour(fname(f));
  }
  function pickFlavour(f) {
    gallerySel = null;
    state.flavour = f.id;
    state.picks[0] = f.id;
    theme();
    splash(f);
    var hf = $('wb-heroflav');
    if (hf) hf.textContent = f.note[LANG] || hf.textContent;
    renderFlavours();
    renderSlots();
    renderStack();
    renderTake();
  }

  function renderFlavours() {
    var h = $('wb-fgrid');
    h.innerHTML = '';
    fl().forEach(function (f) {
      var b = document.createElement('button');
      b.className = 'wb-fblock';
      b.type = 'button';
      b.disabled = !f.available;
      b.setAttribute('aria-pressed', String(state.flavour === f.id));
      b.style.background = 'linear-gradient(155deg,' + hsl(f.h, f.s, 74) + ',' + hsl(f.h, f.s, 54) + ')';
      var dot = document.createElement('span');
      dot.className = 'wb-fb-dot';
      var inr = document.createElement('span');
      inr.className = 'wb-fb-in';
      var n = document.createElement('span');
      n.className = 'wb-fb-n';
      n.textContent = fname(f);
      var s = document.createElement('span');
      s.className = 'wb-fb-s';
      s.textContent = f.available ? f.note[LANG] : T().soldOut;
      inr.appendChild(n);
      inr.appendChild(s);
      b.appendChild(dot);
      var ph = photoUrl(f.photo);
      if (ph) {
        var im = document.createElement('img');
        im.className = 'wb-fb-img';
        im.src = ph;
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        b.appendChild(im);
      }
      b.appendChild(inr);
      b.addEventListener('click', function () { pickFlavour(f); });
      h.appendChild(b);
    });
  }

  function renderQty() {
    var h = $('wb-qty'), t = T();
    h.innerHTML = '';
    h.setAttribute('aria-label', t.buildEyebrow);
    for (var q = 1; q <= MAX; q++) {
      (function (q) {
        var b = document.createElement('button');
        b.className = 'wb-qbtn';
        b.type = 'button';
        b.setAttribute('aria-pressed', String(state.qty === q));
        b.innerHTML = '<span class="wb-n"></span><span class="wb-s"></span>';
        b.querySelector('.wb-n').textContent = q + ' ' + word(q);
        var off = DATA.stackEnabled ? STACK[q] : 0;
        if (off) b.querySelector('.wb-s').innerHTML = '<b>−' + Math.round(off * 100) + (LANG === 'fr' ? ' %' : '%') + '</b>';
        else b.querySelector('.wb-s').textContent = q === 1 ? t.single : '×' + q;
        b.addEventListener('click', function () {
          state.qty = q;
          renderQty();
          renderSlots();
          renderStack();
          price();
          if (q > 1 && state.picks[q - 1]) splash(flavById(state.picks[q - 1]));
        });
        h.appendChild(b);
      })(q);
    }
  }

  function renderSlots() {
    var h = $('wb-slots'), t = T();
    h.innerHTML = '';
    for (var i = 0; i < state.qty; i++) {
      (function (i) {
        var f = state.picks[i] ? flavById(state.picks[i]) : firstAvailable(state.line);
        state.picks[i] = f.id;
        var row = document.createElement('div');
        row.className = 'wb-slot';
        var idx = document.createElement('span');
        idx.className = 'wb-idx';
        idx.textContent = '0' + (i + 1);
        var chip = document.createElement('span');
        chip.className = 'wb-chip';
        chip.style.background = hsl(f.h, f.s, 60);
        var lbl = document.createElement('label');
        lbl.className = 'wb-lbl';
        var selId = 'wb-slot-' + state.line + '-' + i;
        lbl.setAttribute('for', selId);
        lbl.textContent = i === 0 ? t.front : t.behind(i);
        var sel = document.createElement('select');
        sel.id = selId;
        sel.setAttribute('aria-label', t.flavourLbl + ' ' + (i + 1));
        fl().forEach(function (x) {
          var o = document.createElement('option');
          o.value = x.id;
          o.textContent = fname(x) + (x.available ? '' : ' — ' + t.soldOut);
          o.disabled = !x.available;
          if (x.id === f.id) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          state.picks[i] = sel.value;
          var nf = flavById(sel.value);
          if (i === 0) {
            gallerySel = null;
            state.flavour = sel.value;
            theme();
            renderFlavours();
            renderTake();
            var hf = $('wb-heroflav');
            if (hf) hf.textContent = nf.note[LANG] || hf.textContent;
          }
          splash(nf);
          renderSlots();
          renderStack();
        });
        row.appendChild(idx);
        row.appendChild(chip);
        row.appendChild(lbl);
        row.appendChild(sel);
        h.appendChild(row);
      })(i);
    }
  }

  /* ---------------------------------------------------------- pricing */
  function unitPrice(line) {
    var fs = FLAVOURS[line || state.line];
    var min = Infinity;
    fs.forEach(function (f) { if (f.price < min) min = f.price; });
    return isFinite(min) ? min : 0;
  }
  function price() {
    var t = T(), q = state.qty, unit = unitPrice();
    var sub = unit * q;
    var so = DATA.stackEnabled ? STACK[q] : 0;
    var after = Math.round(sub * (1 - so));
    var lo = DATA.launchEnabled ? LAUNCH_OFF : 0;
    var total = Math.round(after * (1 - lo));
    setT('wb-k-sub', q + ' × ' + money(unit));
    setT('wb-v-sub', money(sub));
    var rb = $('wb-r-bundle');
    if (so > 0) {
      rb.hidden = false;
      setT('wb-k-bundle', t.stackOff(Math.round(so * 100)));
      setT('wb-v-bundle', '−' + money(sub - after));
    } else rb.hidden = true;
    var rl = $('wb-r-launch');
    if (lo > 0) {
      rl.hidden = false;
      setT('wb-v-launch', '−' + money(after - total));
    } else rl.hidden = true;
    setT('wb-v-total', money(total));
    var w = $('wb-v-was');
    if (total < sub) { w.hidden = false; w.textContent = money(sub); } else w.hidden = true;
    setT('wb-v-unit', q > 1 ? money(Math.round(total / q)) + t.perStick : '');
    if (!state.busy) setT('wb-cta', t.cta);
  }

  /* ------------------------------------------------------------- cart */
  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    opts.credentials = 'same-origin';
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) {
          var err = new Error(body && (body.description || body.message) || 'cart error');
          err.body = body;
          throw err;
        }
        return body;
      });
    });
  }
  function refreshCart() {
    return jsonFetch(DATA.routes.cart).then(function (cart) {
      state.cart = cart;
      renderCart();
      return cart;
    });
  }
  function renderCart() {
    var t = T(), cart = state.cart;
    var n = cart ? cart.item_count : 0;
    var badge = $('wb-cbadge');
    badge.hidden = n === 0;
    badge.textContent = String(n);
    var host = $('wb-ditems');
    host.innerHTML = '';
    if (!cart || !cart.items.length) {
      var e = document.createElement('p');
      e.className = 'wb-dempty';
      e.textContent = t.cartEmpty;
      host.appendChild(e);
      $('wb-d-checkout').disabled = true;
    } else {
      $('wb-d-checkout').disabled = false;
      cart.items.forEach(function (it) {
        var ix = VARIANT_INDEX[it.variant_id];
        var f = ix ? ix.flavour : null;
        var row = document.createElement('div');
        row.className = 'wb-ditem';
        var chip = document.createElement('span');
        chip.className = 'wb-chip';
        chip.style.background = f ? 'linear-gradient(150deg,' + hsl(f.h, f.s, 86) + ',' + hsl(f.h, f.s, 66) + ')' : 'var(--wb-acc)';
        var thumb = f ? photoUrl(f.photo) : '';
        if (thumb) {
          chip.classList.add('wb-thumb');
          var ti = document.createElement('img');
          ti.src = thumb;
          ti.alt = '';
          ti.decoding = 'async';
          chip.appendChild(ti);
        }
        var tt = document.createElement('div');
        tt.className = 'wb-t';
        var b = document.createElement('b');
        b.textContent = ix ? 'Winterbreathe ' + lname(ix.line) : it.product_title;
        var s = document.createElement('span');
        s.textContent = it.quantity + ' × ' + (f ? fname(f) : it.variant_title || '');
        tt.appendChild(b);
        tt.appendChild(s);
        var p = document.createElement('span');
        p.className = 'wb-p';
        if (it.original_line_price > it.final_line_price) {
          var was = document.createElement('s');
          was.textContent = money(it.original_line_price);
          p.appendChild(was);
        }
        p.appendChild(document.createTextNode(money(it.final_line_price)));
        var rm = document.createElement('button');
        rm.className = 'wb-drm';
        rm.type = 'button';
        rm.setAttribute('aria-label', t.remove + ' ' + (f ? fname(f) : it.title));
        rm.innerHTML = '&times;';
        rm.addEventListener('click', function () {
          rm.disabled = true;
          jsonFetch(DATA.routes.cartChange, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: 0 })
          }).then(function (cart) {
            state.cart = cart;
            renderCart();
          }).catch(function () {
            rm.disabled = false;
            toast(t.addError);
          });
        });
        row.appendChild(chip);
        row.appendChild(tt);
        row.appendChild(p);
        row.appendChild(rm);
        host.appendChild(row);
      });
    }
    setT('wb-d-tv', money(cart ? cart.total_price : 0));
    renderCartSummary(cart);
  }
  /* Discount breakdown above the cart total: lot discounts (per line) and the
   * launch code (order level), exactly as Shopify reports them in /cart.js. */
  function renderCartSummary(cart) {
    var box = $('wb-d-sum'), t = T();
    if (!box) return;
    box.innerHTML = '';
    var rows = [], byTitle = {};
    if (cart && cart.items) {
      cart.items.forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var k = a.discount_application && a.discount_application.title || '';
          byTitle[k] = (byTitle[k] || 0) + a.amount;
        });
      });
      Object.keys(byTitle).forEach(function (k) { if (byTitle[k] > 0) rows.push([k, byTitle[k]]); });
      (cart.cart_level_discount_applications || []).forEach(function (a) {
        if (a.total_allocated_amount > 0) rows.push([a.title, a.total_allocated_amount]);
      });
    }
    if (!rows.length) { box.hidden = true; return; }
    function row(k, v, save) {
      var d = document.createElement('div');
      d.className = 'wb-row' + (save ? ' wb-save' : '');
      var a = document.createElement('span');
      a.textContent = k;
      var b = document.createElement('span');
      b.className = 'wb-v';
      b.textContent = v;
      d.appendChild(a);
      d.appendChild(b);
      box.appendChild(d);
    }
    row(t.subtotal, money(cart.original_total_price));
    var total = 0;
    rows.forEach(function (r) { total += r[1]; row(r[0], '−' + money(r[1]), true); });
    row(t.saved(money(total)), '', true);
    box.hidden = false;
  }
  var lastFocus = null;
  function openCart(o) {
    var d = $('wb-drawer');
    d.classList.toggle('wb-on', o);
    d.setAttribute('aria-hidden', String(!o));
    $('wb-scrim').classList.toggle('wb-on', o);
    if (o) {
      lastFocus = document.activeElement;
      $('wb-dclose').focus();
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }
  function flyToCart() {
    if (reduce) return;
    var src = document.querySelector('#wb-stack .wb-stick:not(.wb-ghost)');
    var dst = $('wb-cartbtn');
    if (!src || !dst || !src.animate) return;
    var a = src.getBoundingClientRect(), b = dst.getBoundingClientRect();
    var el = document.createElement('div');
    el.className = 'wb-flyer';
    el.style.left = a.left + 'px';
    el.style.top = a.top + 'px';
    el.style.width = a.width + 'px';
    el.style.height = a.height + 'px';
    el.innerHTML = src.innerHTML;
    root.appendChild(el);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var an = el.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.42 - 130) + 'px) scale(.52) rotate(-16deg)', opacity: 0.95, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.1) rotate(10deg)', opacity: 0 }
    ], { duration: 760, easing: 'cubic-bezier(.4,.05,.3,1)' });
    an.onfinish = function () { el.remove(); };
  }
  function applyLaunchCode() {
    if (!DATA.launchEnabled || !DATA.launchCode) return Promise.resolve();
    var flag = 'wb-launch-' + DATA.launchCode;
    try { if (sessionStorage.getItem(flag)) return Promise.resolve(); } catch (e) {}
    return fetch('/discount/' + encodeURIComponent(DATA.launchCode) + '?redirect=' + encodeURIComponent(DATA.routes.cart), { credentials: 'same-origin' })
      .then(function () { try { sessionStorage.setItem(flag, '1'); } catch (e) {} })
      .catch(function () {});
  }
  function addToCart() {
    if (state.busy) return;
    var t = T(), q = state.qty;
    var counts = {};
    state.picks.slice(0, q).forEach(function (id) {
      var f = flavById(id);
      if (!f || !f.available) return;
      counts[f.variantId] = (counts[f.variantId] || 0) + 1;
    });
    var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    if (!items.length) { toast(t.addError); return; }
    state.busy = true;
    var cta = $('wb-cta');
    cta.disabled = true;
    cta.textContent = t.adding;
    jsonFetch(DATA.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function () {
        flyToCart();
        if (state.flavour) splash(flavById(state.flavour));
        try { if (navigator.vibrate) navigator.vibrate(10); } catch (e) {}
        return applyLaunchCode().then(refreshCart, refreshCart);
      })
      .then(function () {
        var badge = $('wb-cbadge');
        setTimeout(function () {
          badge.classList.remove('wb-bump');
          void badge.offsetWidth;
          badge.classList.add('wb-bump');
        }, reduce ? 0 : 560);
        toast(t.added(q, word(q)));
      })
      .catch(function (err) {
        toast((err && err.body && err.body.description) || t.addError);
      })
      .then(function () {
        state.busy = false;
        cta.disabled = false;
        cta.textContent = t.cta;
      });
  }

  var tt;
  function toast(m) {
    var e = $('wb-toast');
    e.textContent = m;
    e.classList.add('wb-up');
    clearTimeout(tt);
    tt = setTimeout(function () { e.classList.remove('wb-up'); }, 3200);
  }

  /* --------------------------------------------------- falling fruit */
  var cv = $('wb-fruitfall'), ctx = cv.getContext('2d');
  var W = 0, H = 0, bits = [];
  function sizeCanvas() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth;
    H = window.innerHeight;
    cv.width = Math.floor(W * dpr);
    cv.height = Math.floor(H * dpr);
    cv.style.width = W + 'px';
    cv.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function curF() { return state.flavour ? flavById(state.flavour) : null; }
  function makeBit() {
    var f = curF(), c = paintOf(f), d = 0.35 + Math.random() * 0.9;
    return {
      x: Math.random() * W, y: Math.random() * H, r: (11 + Math.random() * 21) * d, depth: d,
      vy: (0.22 + Math.random() * 0.55) * d, rot: Math.random() * 6.28, spin: (Math.random() - 0.5) * 0.013,
      wob: Math.random() * 6.28, wobSpd: 0.006 + Math.random() * 0.012, wobAmp: 8 + Math.random() * 22,
      kind: f ? f.fruit : 'shardy', hi: c.hi, mid: c.mid, lo: c.lo, shard: Math.random() < (f ? 0.22 : 0.78)
    };
  }
  function seed() {
    bits = [];
    var n = Math.round(Math.min(34, Math.max(13, W / 44)));
    for (var i = 0; i < n; i++) bits.push(makeBit());
  }
  function recolour() {
    var f = curF(), c = paintOf(f);
    bits.forEach(function (b) {
      b.hi = c.hi; b.mid = c.mid; b.lo = c.lo;
      b.kind = f ? f.fruit : 'shardy';
      if (!f) b.shard = true;
    });
  }
  function ball(b, x, y, r) {
    var g = ctx.createRadialGradient(x - r * 0.36, y - r * 0.42, r * 0.12, x, y, r * 1.06);
    g.addColorStop(0, b.hi); g.addColorStop(0.45, b.mid); g.addColorStop(1, b.lo);
    ctx.fillStyle = g;
    ctx.beginPath(); ctx.arc(x, y, r, 0, 6.284); ctx.fill();
    ctx.fillStyle = 'rgba(255,255,255,.34)';
    ctx.beginPath(); ctx.ellipse(x - r * 0.34, y - r * 0.4, r * 0.24, r * 0.16, -0.5, 0, 6.284); ctx.fill();
  }
  function drawBit(b) {
    var x = b.x + Math.sin(b.wob) * b.wobAmp, y = b.y;
    ctx.save();
    ctx.globalAlpha = 0.16 + b.depth * 0.34;
    ctx.translate(x, y); ctx.rotate(b.rot); ctx.translate(-x, -y);
    if (b.shard) {
      ctx.fillStyle = b.hi;
      ctx.globalAlpha *= 0.85;
      ctx.beginPath();
      ctx.moveTo(x, y - b.r); ctx.lineTo(x + b.r * 0.42, y); ctx.lineTo(x, y + b.r * 0.82); ctx.lineTo(x - b.r * 0.42, y);
      ctx.closePath(); ctx.fill();
    } else if (b.kind === 'cluster') {
      ball(b, x - b.r * 0.42, y + b.r * 0.3, b.r * 0.6);
      ball(b, x + b.r * 0.42, y + b.r * 0.3, b.r * 0.6);
      ball(b, x, y - b.r * 0.34, b.r * 0.64);
    } else if (b.kind === 'leaf') {
      var g = ctx.createLinearGradient(x - b.r, y - b.r, x + b.r, y + b.r);
      g.addColorStop(0, b.hi); g.addColorStop(1, b.lo);
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.moveTo(x, y - b.r);
      ctx.quadraticCurveTo(x + b.r * 0.92, y, x, y + b.r);
      ctx.quadraticCurveTo(x - b.r * 0.92, y, x, y - b.r); ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,.34)';
      ctx.lineWidth = Math.max(1, b.r * 0.07);
      ctx.beginPath(); ctx.moveTo(x, y - b.r * 0.82); ctx.lineTo(x, y + b.r * 0.82); ctx.stroke();
    } else {
      ball(b, x, y, b.r);
      if (b.kind === 'citrus') {
        ctx.strokeStyle = 'rgba(255,255,255,.26)';
        ctx.lineWidth = Math.max(1, b.r * 0.075);
        ctx.beginPath(); ctx.arc(x, y, b.r * 0.62, -0.9, 0.9); ctx.stroke();
      }
      ctx.fillStyle = b.lo;
      ctx.globalAlpha *= 0.9;
      ctx.beginPath(); ctx.ellipse(x + b.r * 0.3, y - b.r * 0.86, b.r * 0.3, b.r * 0.13, -0.6, 0, 6.284); ctx.fill();
    }
    ctx.restore();
  }
  var raf = 0;
  function tick() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < bits.length; i++) {
      var b = bits[i];
      b.y += b.vy; b.rot += b.spin; b.wob += b.wobSpd;
      if (b.y - b.r > H + 30) {
        var f = curF(), c = paintOf(f);
        b.y = -b.r - Math.random() * 120;
        b.x = Math.random() * W;
        b.hi = c.hi; b.mid = c.mid; b.lo = c.lo;
        b.kind = f ? f.fruit : 'shardy';
        b.shard = Math.random() < (f ? 0.22 : 0.78);
      }
      drawBit(b);
    }
    raf = requestAnimationFrame(tick);
  }
  function splash(f) {
    recolour();
    if (reduce || !f) return;
    var c = paintOf(f), cx = W * 0.5, cy = H * 0.34;
    for (var i = 0; i < 11; i++) {
      var b = makeBit();
      b.x = cx + (Math.random() - 0.5) * 140;
      b.y = cy + (Math.random() - 0.5) * 90;
      b.vy = 0.9 + Math.random() * 1.7;
      b.wobAmp = 30 + Math.random() * 42;
      b.hi = c.hi; b.mid = c.mid; b.lo = c.lo; b.kind = f.fruit; b.shard = Math.random() < 0.16;
      bits.push(b);
    }
    while (bits.length > 56) bits.shift();
  }
  document.addEventListener('visibilitychange', function () {
    if (reduce) return;
    if (document.hidden) cancelAnimationFrame(raf);
    else raf = requestAnimationFrame(tick);
  });

  /* ------------------------------------------------------------- boot */
  function renderAll() {
    renderSeg();
    renderCopy();
    renderFlavours();
    renderQty();
    renderSlots();
    renderStack();
    price();
    renderCart();
  }
  function scrollToId(id) {
    var el = $(id);
    if (el) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  state.picks = defaultPicks(state.line);
  theme();
  renderAll();
  $('wb-cta').addEventListener('click', addToCart);
  $('wb-cartbtn').addEventListener('click', function () { openCart(true); });
  $('wb-dclose').addEventListener('click', function () { openCart(false); });
  $('wb-scrim').addEventListener('click', function () { openCart(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $('wb-drawer').classList.contains('wb-on')) openCart(false);
  });
  $('wb-btn-shop').addEventListener('click', function () { scrollToId('wb-flavours'); });
  /* "Choisir ce goût": one stick of the current flavour, straight to the price panel. */
  $('wb-btn-take').addEventListener('click', function () {
    if (!state.flavour) return;
    state.qty = 1;
    state.picks[0] = state.flavour;
    renderQty();
    renderSlots();
    renderStack();
    price();
    scrollToId('wb-builder');
    var cta = $('wb-cta');
    if (cta) setTimeout(function () { cta.focus({ preventScroll: true }); }, reduce ? 0 : 600);
  });
  $('wb-btn-learn').addEventListener('click', function () { scrollToId('wb-why'); });
  sizeCanvas();
  seed();
  if (!reduce) raf = requestAnimationFrame(tick);
  else { ctx.clearRect(0, 0, W, H); bits.forEach(drawBit); }
  var rz;
  window.addEventListener('resize', function () {
    clearTimeout(rz);
    rz = setTimeout(function () { sizeCanvas(); seed(); }, 180);
  });
  refreshCart().catch(function () {});
})();
